export default __webpack_public_path__ + "static/media/computerladyDellLogoRemoved.7ff718f4.jpg";